export var SearchDocumentType;
(function (SearchDocumentType) {
    SearchDocumentType["All"] = "all";
    SearchDocumentType["Pages"] = "public/site/pages";
    SearchDocumentType["Products"] = "public/stores/products";
    SearchDocumentType["Blogs"] = "public/blog/posts";
    SearchDocumentType["Forums"] = "public/forum/content";
    SearchDocumentType["Bookings"] = "public/booking/services";
    SearchDocumentType["Events"] = "public/events/events";
})(SearchDocumentType || (SearchDocumentType = {}));
//# sourceMappingURL=api.types.js.map